import { Injectable } from '@angular/core';
import {ResourcesService} from '../resources.service';
import {Booking} from '../../model/booking';
import {UserService} from '../user/user.service';
import {Observable} from 'rxjs/Observable';
import {PageResultBookings} from '../../model/page-result-bookings';
import {AuthenticationService} from '../../authentication/authentication.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {RequestOptions, ResponseContentType} from '@angular/http';

@Injectable()
export class AgentReservationService {

  constructor(
    private _http: HttpClient,
    private _auth: AuthenticationService,
    private _resources: ResourcesService,
    private _userService: UserService) { }

  getBookings(
    pageSize: number,
    page = 1,
    supplierId?: number,
    status?: string,
    from?: string,
    to?: string,
    search?: string
  ): Observable<PageResultBookings> {
    let url = 'AgentReservation/AgentSalesList?' +
      'page=' + (page !== 0 ? page : 1) +
      '&pageSize=' + pageSize;

    if (supplierId) {
      url += '&s.supplierId=' + supplierId;
    }

    if (status) {
      url += '&s.status=' + status;
    }

    if (from) {
      url += '&s.bookingDateStart=' + from;
    }

    if (to) {
      url += '&s.bookingDatetEnd=' + to;
    }

    if (search) {
      url += '&s.search=' + search;
    }

    return this._resources.get(url);
  }

  downloadBookings(
    eventId?: number,
    productId?: number,
    supplierId?: number,
    status?: string,
    paymentStatus?: string,
    withTransport?: boolean,
    withNote?: boolean,
    from?: string,
    to?: string,
    search?: string
  ) {
    let url = 'AgentReservation/AgentSalesDownload?' +
      'agentId=' + this._userService.userAccountTypeDefault.agent.id;

    if (eventId) {
      url += '&s.eventId=' + eventId;
    }

    if (productId) {
      url += '&s.supplierId=' + productId;
    }

    if (supplierId) {
      url += '&s.supplierId=' + supplierId;
    }

    if (status) {
      url += '&s.status=' + status;
    }

    if (paymentStatus) {
      url += '&s.paymentStatus=' + paymentStatus;
    }

    if (withTransport !== undefined) {
      url += '&s.withTransport=' + withTransport;
    }

    if (withNote !== undefined) {
      url += '&s.withNote=' + status;
    }

    if (from) {
      url += '&s.bookingDateStart=' + from;
    }

    if (to) {
      url += '&s.bookingDatetEnd=' + to;
    }

    if (search) {
      url += '&s.search=' + search;
    }

    return this._resources.get(url, true, 'blob', 'response');
  }

  createReservation(booking: Booking): Observable<Booking> {
    return this._resources.post('AgentReservation/ReservationCreate', {
      agentId: this._userService.userAccountTypeDefault.agentId,
      by: this._userService.by,
      supplierId: booking.event.supplierId,
      reservation: booking
    });
  }

  getAllRoutes(supplierId: number | string) {
    return this._resources.get('AgentReservation/GetAllRoutes?' +
      'agentId=' + this._userService.userAccountTypeDefault.agent.id +
      '&supplierId=' + supplierId);
  }

  findBooking(bookingId: number | string): Observable<Booking | Booking[]> {
    return this._resources.get('AgentReservation/FindBooking?' +
      'agentId=' + this._userService.userAccountTypeDefault.agent.id +
      '&bookingId=' + bookingId);
  }

  findReservationBySupplier(supplierId: number | string, bookingId: number | string): Observable<Booking> {
    return this._resources.get('AgentReservation/FindReservationBySupplier?' +
      'agentId=' + this._userService.userAccountTypeDefault.agent.id +
      '&supplierId=' + supplierId +
      '&reservationId=' + bookingId);
  }

  confirmBookingRefundCode(supplierId: number | string, bookingId: number | string, refundCode: string): Observable<any> {
    return this._resources.post('AgentReservation/RefundConfirmation', {
      agent: this._userService.userAccountTypeDefault.agent,
      userAccount: this._userService.user,
      supplierId: supplierId,
      bookingId: bookingId,
      refundCode: refundCode
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/api/resources/agent-reservation/agent-reservation.service.ts